import { withBasePathForAssets } from '@/utils/base-path';

export const COMPETITION_SECTIONS = ['features', 'shorts', 'documentary'] as const;

export type CompetitionSection = (typeof COMPETITION_SECTIONS)[number];

export type CompetitionProgramBackgrounds = Record<CompetitionSection, string>;

const STATIC_FALLBACKS: Record<CompetitionSection, string> = {
    features: '/img/program/features.jpg',
    shorts: '/img/program/shorts.jpg',
    documentary: '/img/program/documentary.jpg',
};

export const isCompetitionSection = (value: string): value is CompetitionSection =>
    (COMPETITION_SECTIONS as readonly string[]).includes(value);

export const fallbackCompetitionProgramBackgrounds = (
    basePath: string,
): CompetitionProgramBackgrounds => ({
    features: withBasePathForAssets(STATIC_FALLBACKS.features, basePath),
    shorts: withBasePathForAssets(STATIC_FALLBACKS.shorts, basePath),
    documentary: withBasePathForAssets(STATIC_FALLBACKS.documentary, basePath),
});

export const competitionImagePublicUrl = (storagePath: string): string => {
    if (/^https?:\/\//i.test(storagePath)) {
        return storagePath;
    }

    const cleaned = storagePath.replace(/^\/+/, '');
    const origin = process.env.NEXT_PUBLIC_SUPABASE_URL?.replace(/\/$/, '') || '';
    return `${origin}/storage/v1/object/public/assets/${cleaned}`;
};
